import { orderBy, partition, get, isNil } from "lodash"
import { ASC } from "helpers/sorts"
import { checkIsHighlighted } from "renderers/contributors-table/helpers"

export const sortContributors = ({
  contributorsArray,
  sortMetricId,
  sortArrowDirection,
  isAbsoluteSort,
  highlightedRowIds,
  metricMetadata,
}) => {
  if (!sortMetricId) return contributorsArray

  const [pinnedContributors, unpinnedContributors] = partition(contributorsArray, (contributor) =>
    contributor.pinnedRowOrder || checkIsHighlighted(contributor, highlightedRowIds),
  )

  const sortedPinnedContributors = orderBy(pinnedContributors, ["pinnedRowOrder", "label"], [ASC, "asc"])

  let sortedUnpinnedContributors
  if (sortMetricId === "label") {
    sortedUnpinnedContributors = orderBy(unpinnedContributors, "label", sortArrowDirection)
  } else {
    const sortMetric = metricMetadata?.find(m => m.id === sortMetricId)
    if (!sortMetric) {
      return contributorsArray
    }

    const getValueForContributor = (contributor) => {
      return sortMetric.dataGetter
        ? sortMetric.dataGetter(contributor.values)
        : get(contributor, `values.${sortMetric.dataPath}`)
    }

    const [nilContributors, valueContributors] = partition(unpinnedContributors, (contributor) => {
      const value = getValueForContributor(contributor)
      return isNil(value)
    })

    const sortedValueContributors = orderBy(valueContributors, (contributor) => {
      const value = getValueForContributor(contributor)
      return isAbsoluteSort ? Math.abs(value) : value
    }, sortArrowDirection)

    sortedUnpinnedContributors = [
      ...sortedValueContributors,
      ...orderBy(nilContributors, "label", "asc"),
    ]
  }

  return [...sortedPinnedContributors, ...sortedUnpinnedContributors]
}
